// src/oura/components/fixes/PlanUnreadable.tsx
//
// Fixes when the plan itself could not be read. The recommendations came with
// the scan, not with the plan, so they are still listed: every one, high
// priority first, as Overview's list used to show them. Whether the plan
// covers each one cannot be known without the plan, so no row claims it.

import { LightbulbIcon } from "lucide-react";
import type { Recommendation } from "../../audit";
import { FoldCard, FoldScope, PageSentence } from "@oura/ui";
import { PlanGapRow } from "./FixRows";
import { PRIORITY_RANK, checkKeyOfRec } from "./model";

export function PlanUnreadable({
    recommendations,
    onOpenIssue,
}: {
    /** The scan's recommendations, in the order the backend sent them. */
    recommendations: Recommendation[];
    /** Open a finding on Site issues. Absent leaves the rows without a link. */
    onOpenIssue?: (issueKey: string) => void;
}) {
    const recs = recommendations.slice().sort((a, b) => PRIORITY_RANK[a.priority] - PRIORITY_RANK[b.priority]);
    return (
        <FoldScope value="staff-fixes">
            <PageSentence>The plan could not be read. Reload the page to try again.</PageSentence>
            {recs.length > 0 && (
                <FoldCard id="recommendations" title="Recommendations" icon={{ icon: LightbulbIcon, area: "work" }} foldedFact={`${recs.length}`}>
                    {recs.map((rec) => {
                        const key = checkKeyOfRec(rec.id);
                        return (
                            <PlanGapRow
                                key={rec.id}
                                rec={rec}
                                planKnown={false}
                                onOpenCheck={key && onOpenIssue ? () => onOpenIssue(key) : undefined}
                            />
                        );
                    })}
                </FoldCard>
            )}
        </FoldScope>
    );
}
